export default __webpack_public_path__ + "static/media/heart_filled-min.1160c41f.png";